import { apiFetch } from "../client"

export function getPerformanceTeamSummary(params?: Record<string, string>) {
  const query = params ? `?${new URLSearchParams(params).toString()}` : ""
  return apiFetch<any>(`/performance/team-summary${query}`)
}

export function getPerformanceLeaderboard(params?: Record<string, string>) {
  const query = params ? `?${new URLSearchParams(params).toString()}` : ""
  return apiFetch<any>(`/performance/leaderboard${query}`)
}
